import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const COMPANY = "HELIOPOLIS PHARMACEUTICALS";
const safe = (s) => String(s || "Sheet").replace(/[\\/?*[\]:]/g, " ").slice(0, 31);

export function exportExcel(sheets, filename, periodLabel) {
  const wb = XLSX.utils.book_new();
  sheets.filter((s) => s && s.rows).forEach((s) => {
    const rows = s.rows.length ? s.rows : [{ note: "No data in this period" }];
    const ws = XLSX.utils.json_to_sheet([{ [Object.keys(rows[0])[0]]: `${s.name} — ${periodLabel}` }, {}, ...rows], { skipHeader: false });
    ws["!freeze"] = { xSplit: 0, ySplit: 3 };
    ws["!cols"] = Object.keys(rows[0]).map((k) => ({ wch: Math.min(40, Math.max(12, k.length + 4)) }));
    XLSX.utils.book_append_sheet(wb, ws, safe(s.name));
  });
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export async function exportPdf(elementId, title, periodLabel, filename) {
  const el = document.getElementById(elementId);
  if (!el) return;
  const canvas = await html2canvas(el, { scale: 1.5, useCORS: true, backgroundColor: "#ffffff" });
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = pdf.internal.pageSize.getWidth(), H = pdf.internal.pageSize.getHeight(), m = 12, headH = 26;
  const drawHead = () => {
    pdf.setFont("helvetica", "bold"); pdf.setFontSize(9); pdf.setTextColor(30, 127, 212); pdf.text(COMPANY, m, 12);
    pdf.setFontSize(14); pdf.setTextColor(13, 27, 42); pdf.text(title, m, 19);
    pdf.setFont("helvetica", "normal"); pdf.setFontSize(9); pdf.setTextColor(100, 116, 139);
    pdf.text(`Period: ${periodLabel}  ·  Generated ${new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}`, m, 24);
    pdf.setDrawColor(30, 127, 212); pdf.setLineWidth(0.6); pdf.line(m, headH, W - m, headH);
  };
  const imgW = W - 2 * m, pxPerMm = canvas.width / imgW, pageBodyPx = Math.floor((H - headH - m - 4) * pxPerMm);
  for (let y = 0, page = 0; y < canvas.height; y += pageBodyPx, page++) {
    if (page) pdf.addPage();
    drawHead();
    const slice = document.createElement("canvas");
    slice.width = canvas.width; slice.height = Math.min(pageBodyPx, canvas.height - y);
    slice.getContext("2d").drawImage(canvas, 0, y, canvas.width, slice.height, 0, 0, canvas.width, slice.height);
    pdf.addImage(slice.toDataURL("image/jpeg", 0.85), "JPEG", m, headH + 4, imgW, slice.height / pxPerMm);
  }
  pdf.save(`${filename}.pdf`);
}
